import { createContext, useContext, useState, useEffect, useCallback, ReactNode } from 'react'

interface AccessibilityContextType {
  starfieldEnabled: boolean
  toggleStarfield: () => void
}

const AccessibilityContext = createContext<AccessibilityContextType | null>(null)

export function AccessibilityProvider({ children }: { children: ReactNode }) {
  const [starfieldEnabled, setStarfieldEnabled] = useState(() => {
    const stored = localStorage.getItem('accessibility-starfield')
    // Default to true (enabled) if not set
    return stored === null ? true : stored === 'true'
  })

  useEffect(() => {
    localStorage.setItem('accessibility-starfield', starfieldEnabled.toString())
  }, [starfieldEnabled])

  const toggleStarfield = useCallback(() => {
    setStarfieldEnabled(prev => !prev)
  }, [])

  return (
    <AccessibilityContext.Provider value={{
      starfieldEnabled,
      toggleStarfield,
    }}>
      {children}
    </AccessibilityContext.Provider>
  )
}

export function useAccessibility() {
  const context = useContext(AccessibilityContext)
  if (!context) {
    throw new Error('useAccessibility must be used within an AccessibilityProvider')
  }
  return context
}
